import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "./index.css";
import "./shared/styles/_styles.scss";
import "src/shared/i18n";

import { store } from "src/app/model";

import { App } from "./app/App";

const rootElement = document.getElementById("root") as HTMLElement;

const basePath = "/";

const root = createRoot(rootElement);

root.render(
  <BrowserRouter basename={basePath}>
    <Provider store={store}>
      <App />
    </Provider>
  </BrowserRouter>,
);
